import PostCard from '../PostCard/PostCard';
import PostCardSkeleton from '../PostCard/PostCardSkeleton';
import { useMyPosts, useSavedPosts, useLikedPosts } from '../../hooks/queries/usePosts';

const UserPosts = ({ userId, curr }) => {
  const myPosts = useMyPosts(userId);
  const savedPosts = useSavedPosts();
  const likedPosts = useLikedPosts(userId);

  const getActiveQuery = () => {
    if (curr === "My") return myPosts;
    if (curr === "Saved") return savedPosts;
    if (curr === "Liked") return likedPosts;
    return { data: [], isLoading: false };
  };

  const { data: posts, isLoading: loading } = getActiveQuery();

  return (
    <div className='p-6 md:p-10 max-w-4xl mx-auto'>
      {loading ? (
        <div className="space-y-4">
          <PostCardSkeleton />
          <PostCardSkeleton />
        </div>
      ) : posts && posts.length > 0 ? (
        posts.map((post) => (
          <div key={post._id} className="mb-6">
            <PostCard post={post} />
          </div>
        ))
      ) : (
        <div className="flex flex-col items-center justify-center py-20 text-slate-300">
          <p className='text-lg font-black uppercase tracking-widest'>No posts yet</p>
        </div>
      )}
    </div>
  );
};

export default UserPosts
